export const REQUESTS_EDIT_DUE_DATE_FIELD_NAME = 'due_date'

export const REQUESTS_EDIT_DUE_DATE_FIELD_NAME_WITHOUT_DATE = 'without_date'

export const REQUEST_EDIT_DUE_DATE_MODAL_QA_NAME = 'dueDate'

export const REQUEST_EDIT_DUE_DATE_MODAL_SUBMIT_QA_NAME = 'Add'
